/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';
import * as X from "@/ui";

import BlogImage from "@/assets/about-us-ressource-blog.svg";
import MediaKitImage from "@/assets/about-us-ressource-mediakit.svg";
import { useAboutUsPage } from "@/providers/strapi/content/types/singleTypes/about-us-page";
import ReactMarkdown from "react-markdown";


export function ResourcesSection(_props: X.PageProps) {
  // const tr = X.useTranslator();

  const { ressourcesSection } = useAboutUsPage('commitmentsCard')

  if (ressourcesSection.ressourceCards.length < 2) throw new Error('Missing ressource card item')
  const cardImageStyle = "h-[100px] w-auto";
  const cardTitleStyle = "font-semibold text-[20px] xl:text-[26px] xl:text-center group-hover:text-black/70";
  const cardTextStyle = "text-[16px] xl:text-[20px] xl:text-center min-h-[120px] group-hover:text-black/70";
  const cardIconStyle = "group-hover:translate-x-2 transition-transform transform-gpu duration-150";
  const cardIconSize = 24;
  const cardLinkStyle = X.clsx(
    "flex-1 flex flex-col xl:py-y xl:py-8 xl:px-16 gap-4 xl:gap-6 xl:border xl:rounded-lg",
    "xl:items-center group cusrsor-pointer"
  );

  return (
    <section id="resources" className={X.clsx("scroll-mt-[120px] relative my-12 xl:mt-24")}>
      <div className="mx-mobile-margin xl:max-w-4xl xl:mx-auto">
        <ReactMarkdown components={{
          p: ({ ...props }) => <h2 {...props} className="text-[35px] xl:text-[48px] [&_strong]:font-medium xl:text-center xl:max-w-content xl:mx-auto mb-6 xl:mb-16 leading-tight" />
        }}>
          {ressourcesSection.title}
        </ReactMarkdown>
        {/* <h2 className="text-[35px] xl:text-[48px] [&_strong]:font-medium xl:text-center xl:max-w-content xl:mx-auto mb-6 xl:mb-16 leading-tight">
          {tr({
            en: <><strong>Resources</strong></>,
            fr: <>Toutes nos <strong>ressources</strong></>,
          })}
        </h2> */}

        <div className="flex flex-row gap-4 xl:gap-12 items-start">
          <X.Link href="/blog" className={cardLinkStyle}>
            <X.Image src={BlogImage} alt="Blog" className={cardImageStyle} />
            {/* <h3 className={cardTitleStyle}>
              {ressourcesSection.ressourceCards[0]?.title}
            </h3> */}

            <ReactMarkdown components={{
              p: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />,
              h1: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />,
              h2: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />,
              h3: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />,
              h4: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />
            }}>
              {ressourcesSection.ressourceCards[0]?.title}
            </ReactMarkdown>
            {/* <p className={cardTextStyle}>
              {ressourcesSection.ressourceCards[0]?.content}
            </p> */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <p {...props} className={cardTextStyle} />,
            }}>
              {ressourcesSection.ressourceCards[0]?.content}
            </ReactMarkdown>
            <X.Icon.MoveRight size={cardIconSize} className={cardIconStyle} />
          </X.Link>

          <X.ExternalLink href={X.links.mediaKit} className={cardLinkStyle}>
            <X.Image src={MediaKitImage} alt="Media Kit" className={cardImageStyle} />
            {/* <h3 className={cardTitleStyle}>
              {ressourcesSection.ressourceCards[1]?.title}
            </h3> */}
            <ReactMarkdown components={{
              p: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />,
              h1: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />,
              h2: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />,
              h3: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />,
              h4: ({ ...props }) => <h3 {...props} className={cardTitleStyle} />
            }}>
              {ressourcesSection.ressourceCards[1]?.title}
            </ReactMarkdown>
            <ReactMarkdown components={{
              p: ({ ...props }) => <p {...props} className={cardTextStyle} />,
            }}>
              {ressourcesSection.ressourceCards[1]?.content}
            </ReactMarkdown>
            {/* <p className={cardTextStyle}>
              {ressourcesSection.ressourceCards[1]?.content}
              {tr({
              en: "Need our logo in RGB or our latest press release?It’s all right here",
              fr: "Notre logo en RVB, le dernier communiqué de presse?",
            })}
            </p> */}
            <X.Icon.MoveRight size={cardIconSize} className={cardIconStyle} />
          </X.ExternalLink>
        </div>
      </div>
    </section>
  );
}
